// Copyright (c) 2017 Deere & Company

const machineStatusSortOptions = [
    {
        displayName: 'PIN',
        path: ['product', 'pin']
    },
    {
        displayName: 'DEALER',
        path: ['product', 'dealer', 'account']
    },
    {
        displayName: 'STATUS',
        path: ['newStatus', 'value']
    },
    {
        displayName: 'CREATED',
        path: ['createdDate']
    }
];

export default machineStatusSortOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/machine-status-sort-options.js